<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="" title="" />
		
			<div class="card">
				<div class="card-body">

					<form @submit.prevent="verifyTicket(ticket_number)">
						<div class="row">
							<div class="col-sm-5 me-5">
								<div class="">
									<!-- <label class="control-label">Ticket Number</label> -->
									<input class="form-control" type="text" placeholder="Enter the ticket number" v-model="ticket_number" v-bind:class="{ 'is-invalid': Boolean(errors.ticket_number) }"/>
                                    <div v-for="(val, index) in errors.ticket_number" :key="index" class="invalid-feedback">
                                        <p class="mb-0">{{ val }}</p>
                                    </div>
									
								</div>
							</div>
										
							<div class="col-sm-1"> <!-- style="margin-top: 40px;" -->
								<button type="submit" class="btn btn-primary float-end">Check</button>
							</div>
						</div>
					</form>
				</div>
			</div>

			<div class="row">
				<div class="col-xxl-12 col-md-12 col-sm-12 box-col-12">
					<div class="appointment">
						<div class="dashboard-card card recent-order">

							<div class="card-header card-no-border">
								<div class="header-top">
									<h5 class="m-0">Verified Tickets</h5>
										
								</div>
							</div>

							<div class="row mt-2 ms-3 mb-4 me-3">
								<div class="col-md-3">
									<div class="card mini-stats-wid">
										<div class="card-body" >
											<div class="media">
												<div class="media-body">
													<p class="mb-0 ">Today</p>
												</div>

												<div class="align-self-center ">
													<span class="float-end me-3">
														<h6 class="font-weight-400">{{ today_tickets }}</h6>
													</span>
												</div>
											</div>
										</div>
									</div>	
								</div>

								<div class="col-md-3">
									<div class="card mini-stats-wid">
										<div class="card-body" >
											<div class="media">
												<div class="media-body">
													<p class="mb-0 ">This Week</p>
												</div>

												<div class="align-self-center ">
													<span class="float-end me-3">
														<h6 class="font-weight-400">{{ this_week_tickets }}</h6>
													</span>
												</div>
											</div>
										</div>
									</div>	
								</div>

								<div class="col-md-3">
									<div class="card mini-stats-wid">
										<div class="card-body" >
											<div class="media">
												<div class="media-body">
													<p class="mb-0 ">This Month</p>
												</div>

												<div class="align-self-center ">
													<span class="float-end me-3">
														<h6 class="font-weight-400">{{ this_month_tickets }}</h6>
													</span>
												</div>
											</div>
										</div>
									</div>	
								</div>

								<div class="col-md-3">
									<div class="card mini-stats-wid">
										<div class="card-body" >
											<div class="media">
												<div class="media-body">
													<p class="mb-0 ">Total</p>
												</div>

												<div class="align-self-center ">
													<span class="float-end me-3">
														<h6 class="font-weight-400">{{ total_used_tickets }}</h6>
													</span>
												</div>
											</div>
										</div>
									</div>	
								</div>
							</div>								
							
							<div class="card-body pt-0">
								<div class="row m-0 overall-card overview-card">
									<div class="col-xl-12 col-md-12 col-sm-12 p-0 box-col-12">
										<div class="chart-right">
											<div class="row">
												<div class="col-xl-12">
													<div class="card-body p-0">
														<div class="current-sale-container order-container">
															<div class="overview-wrapper">
																<apexchart height="265" type="line" :options="ecomDashboard.options2" :series="ecomDashboard.series2"></apexchart>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="card">
				<div class="card-body">
		
					<div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-4">
								<label class="control-label">Start Date:<span class="text-danger">*</span></label>
								<input class="form-control" type="date" v-model="start_date" :min="min" :max="max" value-as-string @input="fetchHome()">
							</div>
							<div class="col-md-4">
								<label class="control-label">End Date:<span class="text-danger">*</span></label>
								<input class="form-control" type="date" v-model="end_date" :min="min" :max="max" value-as-string  @input="fetchHome()">
							</div>
									
							<div class="col-md-4 float-end" style="margin-top: 40px;">
								<!-- <div class="btn btn-info" v-if="Boolean(accessories.length)" @click="generatePDF()">Pdf</div> -->
								<!-- <div class="btn btn-info">Download</div> -->
							</div>
						</div>
					</div>

					<div class="col-md-12 project-list filter-sort mt-5">
						<div class="row">
							<div class="col-md-12">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select" v-model="listing_length" @change="fetchHome()">
										<option value="5">5</option>
										<option value="10">10</option>
										<option value="20">20</option>
									</select>
									<span>entries</span>
								</label>
							</div>
							
						</div>
					</div>
		
					<div class="table-responsive product-table">
						<table class="display" id="basic-1">
							<thead>
								<tr align="center">
									<th>Campaign Id</th>
                                	<th>Ticket Number</th>
									<th>Campaign Name</th>
									<th>Product Name</th>
									<th>Verified On</th>
								</tr>
							</thead>

							<tbody v-if="Boolean(campaign_tickets.length)">
								<tr v-for="tickets in campaign_tickets" align="center">
									<td>{{ tickets.campaign_id }}</td>
									<td>{{ tickets.ticket_number }}</td>
                                    <td>{{ tickets.campaign_name }} {{ tickets.prize_name }}</td>
									<td>{{ tickets.product_name }}</td>
									<td>{{ $filters.formatDateTime(tickets.used_date) }}</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td colspan="8" class="text-center">No Tickets found</td>
								</tr>
							</tbody>
									
						</table>
					</div>
					
					<nav aria-label="Page navigation" class="mt-2">
						<ul class="pagination">
							<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
								<a class="page-link" href="#" @click.prevent="fetchHome(page.url + '&from_date=' + start_date + '&to_date=' + end_date +  '&limit=' + listing_length )" tabindex="-1">
									<span v-if="index == 0">Prev</span>
									<span v-else-if="index == pagination.length - 1">Next</span>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
					</nav>
							
				</div>
			</div>

			<DynamicModal>
				<template #body>
					<form @submit.prevent="Checkout(ticket_details.ticket_number)" enctype="multipart/form-data">
						<div class="row ms-2 me-2 mt-4">
							<div class="mb-3">
								<table>
									<thead style="font-size: medium;">
										<tr style="height:40px;">
											<td>Eligible</td>
											<td style="text-align: left;">:</td>
											<td style="text-align: right;">
												<span class="font-success" v-if="ticket_details.status == 2">Yes</span>
												<span class="font-danger" v-if="ticket_details.status == 1">Used</span>
												<span class="font-warning" v-if="ticket_details.status == 3">Expired</span>
												<span class="font-secondary" v-if="ticket_details.ticket_status == 1"> (Draw Pending)</span>
												<span class="font-secondary" v-if="ticket_details.ticket_status == 2"> (Not Redeemed)</span>
											</td>
															
										</tr> 

										<tr style="height:40px;">
											<td>Name</td>
											<td style="text-align: left;">:</td>
											<td style="text-align: right;">{{ ticket_details.customer }}</td>
										</tr> 

										<tr style="height:40px;">
											<td>Email</td>
											<td style="text-align: left;">:</td>
											<td style="text-align: right;">{{ ticket_details.customer_email }}</td>
										</tr> 

										<tr style="height:40px;">
											<td>Contact No</td>
											<td style="text-align: left;">:</td>
											<td style="text-align: right;">{{ ticket_details.country_code }} {{ ticket_details.customer_mobile }}</td>
										</tr> 
															
									</thead>
								</table>
							</div>
							<hr>
							<div class="mt-3">
								<table>
									<thead style="font-size: medium;">
										<tr style="height:40px;">
											<td>Ticket Number</td>
											<td style="text-align: left;">:</td>
											<td style="text-align: right;">{{ ticket_details.ticket_number }}</td>
															
										</tr> 

										<tr style="height:40px;">
											<td>Draw Date</td>
											<td style="text-align: left;">:</td>
											<td style="text-align: right;">{{ $filters.formatDate(ticket_details.draw_date) }}</td>
										</tr> 

										<tr style="height:40px;">
											<td>Expired On</td>
											<td style="text-align: left;">:</td>
											<td style="text-align: right;">{{ $filters.formatDate(ticket_details.expire_date) }}</td>
										</tr> 

										<tr style="height:40px;">
											<td>Price</td>
											<td style="text-align: left;">:</td>
											<td style="text-align: right;">AED{{ ticket_details.campaign_price }}</td>
										</tr> 

										<tr style="height:40px;">
											<td>Product name</td>
											<td style="text-align: left;">:</td>
											<td style="text-align: right;">{{ ticket_details.product_name }}</td>
										</tr> 

										<tr style="height:40px;">
											<td>Prize name</td>
											<td style="text-align: left;">:</td>
											<td style="text-align: right;">{{ ticket_details.prize_name }}</td>
										</tr> 

										<tr style="height:40px;">
											<td>Campaign name</td>
											<td style="text-align: left;">:</td>
											<td style="text-align: right;">{{ ticket_details.campaign_name }}</td>
										</tr> 
											
										<tr style="height:40px;">
											<td>Campaign Description</td>
											<td style="text-align: left;">:</td>
											<td style="text-align: right;">{{ ticket_details.description }}</td>
										</tr> 

									</thead>
								</table>
							</div>
						</div>

						<div class="row">
							<div class="col-md-12 form-group mt-4" align="center">
								<button type="submit" class="btn btn-primary me-2">Checkout</button>
								<button type="button" class="btn btn-light" @click="closeModal">Cancel</button>
							</div>
						</div>
						
					</form>
				</template>
			</DynamicModal>

	</div>
</template>

<script>
import '@/assets/css/custom.css';
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Dashbord1",

		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

		data() {

				const now = new Date()
				const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
				const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
				const minDate = new Date('2021-01-01') 

			return {
				
				errors: {}, 
				token : "",

				start_date: '2023-01-01',
				end_date: today_str,
				

				ecomDashboard: {

					options2: {

						chart: {
							height: 300,
							type: 'line',
							stacked: false,
							toolbar: {
								show: false
							},
							dropShadow: {
								enabled: true,
								top: 2,
								left: 0,
								blur: 4,
								color: '#000',
								opacity: 0.08
							}
						},
						stroke: {
							width: [2, 2, 2, 2],
							curve: 'smooth'
						},
						grid: {
							show: true,
							borderColor: 'var(--chart-border)',
							strokeDashArray: 0,
							position: 'back',
							xaxis: {
								lines: {
									show: true
								}
							},
							padding: {
								top: 0,
								right: 0,
								bottom: 0,
								left: 0
							},
						},
						plotOptions: {
							bar: {
								columnWidth: '50%'
							}
						},
						colors: ["#FF3364", "#7064F5"],
						// "#FF3364", "#0dcaf0"
						fill: {
							type: 'gradient',
							gradient: {
								shade: 'light',
								type: "vertical",
								opacityFrom: 0.4,
								opacityTo: 0,
								stops: [0, 100]
							}
						},
						labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
						// labels: months
						
						markers: {
							discrete: [
								{
									seriesIndex: 0,
									dataPointIndex: 0,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, 
								{
									seriesIndex: 0,
									dataPointIndex: 1,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, 
								{
									seriesIndex: 0,
									dataPointIndex: 2,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, 
								{
									seriesIndex: 0,
									dataPointIndex: 3,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, 
								{
									seriesIndex: 0,
									dataPointIndex: 4,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, 
								{
									seriesIndex: 0,
									dataPointIndex: 5,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, 
								{
									seriesIndex: 0,
									dataPointIndex: 6,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, 
								{
									seriesIndex: 0,
									dataPointIndex: 7,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, 
								{
									seriesIndex: 0,
									dataPointIndex: 8,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, 
								{
									seriesIndex: 0,
									dataPointIndex: 9,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								},
								{
									seriesIndex: 0,
									dataPointIndex: 10,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, 
								{
									seriesIndex: 0,
									dataPointIndex: 11,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, 
								
							],
							hover: {
								size: 5,
								sizeOffset: 0
							}
						},
						xaxis: {
							type: 'category',
							tickAmount: 10,
							tickPlacement: 'between',
							tooltip: {
								enabled: false,
							},
							axisBorder: {
								color: 'var(--chart-border)',
							},
							axisTicks: {
								show: false
							}
						},
						legend: {
							show: false,
						},
						yaxis: {
							min: 0,
							tickAmount: 6,
							tickPlacement: 'between',
						},
						tooltip: {
							shared: false,
							intersect: false,
						},
						responsive: [{
							breakpoint: 1200,
							options: {
								chart: {
									height: 250,
								}
							},
						}]

					},
					series2: [
						{
							name: 'Used Tickets',
							type: 'area',
							data: []
						},
						
						
					],

				},
				

				months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],

				min: minDate,
				max: today,
				keyword: "",
				listing_length: 10,

				today_tickets : "",
				this_week_tickets : "",
				this_month_tickets : "",
				total_used_tickets : "",

				campaign_tickets : [],
				pagination: {},
				ticket_number: "",

				ticket_details: {},
				
				customer_name: "",

			};

			
		},

		created() {
			this.fetchHome();
		},

		methods: {

			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
				this.clearForm();
			},

			getToken() {
				if (localStorage.getItem('bestdeals_vendor')) {
					var bestdeals_vendor =  JSON.parse(localStorage.getItem('bestdeals_vendor')); 
					
					if(bestdeals_vendor.token) {

						this.token = bestdeals_vendor.token;
						this.user = bestdeals_vendor;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
          	},


			fetchHome(page_url = null) {
				let url = "/home?&limit=" + this.listing_length + "&from_date=" + this.start_date + "&to_date=" + this.end_date;
				page_url = page_url || url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.today_tickets = responseData.today_tickets;
						this.this_week_tickets = responseData.this_week_tickets;
						this.this_month_tickets = responseData.this_month_tickets;
						this.total_used_tickets = responseData.total_used_tickets;

						this.campaign_tickets = responseData.campaign_tickets.data;
						this.pagination = responseData.campaign_tickets.links;
						
						this.ecomDashboard.series2[0].data = responseData.completed_month_tickets;
						
					})
					.catch((err) => console.log(err));
			},

			verifyTicket(ticket_number, page_url = null) {
				let url = "/verifyTicket?&ticket_number=" + ticket_number;
				page_url = page_url || url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.ticket_details = responseData.ticket_details;
						this.openModal();
						
					})
					.catch((error) => {
						console.log(error);
						console.log(error.response);
						if (error.response) {
							if (error.response.status == 422) {
								if (error.response.data) 
								{
									if(error.response.data.message)
									{
										this.errors = error.response.data.message.ticket_number[0];
										this.$swal("", error.response.data.message.ticket_number[0], "error");
									}
								} else {
									this.$swal("", error.response.statusText, "error");
								}
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
					// .catch((err) => console.log(err));
			},

			Checkout(ticket_number) {
				this.getToken();

				const config = {
					headers: {
					"Content-type": "multipart/form-data",
					Accept: "application/json",
					Authorization: "Bearer " + this.token,
					},
				};

				let url = "/ticketCheckout";
				{
					{
					this.token;
					}
				}
				let formData = new FormData();
				formData.append("ticket_number", ticket_number);

				this.$axios
					.post(url, formData, config)
					.then((response) => {
					if (response.data.status) {
						this.$swal("", response.data.message, "success");
					} else {
						this.$swal("", response.data.message, "error");
					}
					this.closeModal();
                  	// this.$router.push({ name: "dashboard" });
					  this.fetchHome(this.active_page_url);
					})
					.catch((error) => {
						console.log(error);
						console.log(error.response);
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			// verifyTicket() {
			// 	this.getToken();

			// 	const config = {
			// 		headers: {
			// 		"Content-type": "multipart/form-data",
			// 		Accept: "application/json",
			// 		Authorization: "Bearer " + this.token,
			// 		},
			// 	};

			// 	let url = "/verifyTicket";
			// 	{
			// 		{
			// 		this.token;
			// 		}
			// 	}
			// 	let formData = new FormData();
			// 	formData.append("ticket_number", this.ticket_number);

			// 	this.$axios
			// 		.post(url, formData, config)
			// 		.then((response) => {
			// 			this.ticket_details = response.data.data;
			// 		if (response.data.status) {
			// 			this.$swal("", response.data.message, "success");
			// 		} else {
			// 			this.$swal("", response.data.message, "error");
			// 		}
			// 		this.openModal(this.ticket_details);
			// 		})
			// 		.catch((error) => {
			// 			console.log(error);
			// 			console.log(error.response);
			// 			if (error.response) {
			// 				if (error.response.data.message) {
			// 					this.errors = error.response.data.message;
			// 					this.$swal("", error.response.data.message, "error");
			// 				} else {
			// 					this.$swal("", "Something went wrong", "error");
			// 				}
			// 			} else {
			// 				this.$swal("", "Something went wrong", "error");
			// 			}
			// 		});
			// },
			
			clearForm() {
				this.ticket_number = "";
			
				this.errors = {};

			},
		},
		
	};
</script>

